import styled from 'styled-components';
import {
  Container as StyledContainer,
  InputContainer,
  ButtonContainer,
  Title,
  Info,
} from '../../GenericListHeader/style';
import { VariationItem } from '../../VariationItem/style';
import { EmptyMessage } from '../../VariationOptionForm/style';
import { FONT_SIZE_5 } from '../../../styles/variables';
import { customScrollbar } from '../../../styles/mixins';

export const StyledEmptyMessage = styled(EmptyMessage)`
  max-width: 175px;
`;

export const Container = styled.div`
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  flex-grow: ${({ isBig }) => (isBig ? 0 : 1)};
  height: 500px;
  margin-right: 30px;
  padding: 30px 30px 10px;
  width: ${({ isBig }) => (isBig ? '653px' : 'auto')};

  ${StyledContainer} {
    align-items: flex-start;
    flex-direction: column;
    flex-shrink: 0;
    margin-bottom: 15px;
  }

  ${ButtonContainer} {
    align-items: flex-start;
    margin-bottom: 20px;
  }

  ${InputContainer} {
    margin-top: 0;
  }

  ${Title} {
    font-size: ${FONT_SIZE_5};
    margin-bottom: 10px;
  }

  ${Info} {
    padding-right: 15px;
    max-width: 250px;
  }

  ${VariationItem} {
    margin-right: 0;
    width: ${({ isBig }) => (isBig ? '593px !important' : '100%')};
  }

  :first-child {
    ${StyledContainer} {
      margin-bottom: 10px;
    }

    ${Info} {
      max-width: 230px;
    }

    ${StyledEmptyMessage} {
      margin: -15px 0 0;
    }
  }

  :last-child {
    margin-right: 0;
  }
`;

export const ItemList = styled.div``;

export const DroppableContainer = styled.div`
  height: 100%;
  margin-right: -16px;
  overflow-y: scroll;
  padding-right: 10px;
  position: relative;

  ${customScrollbar()}

  > .droppable {
    min-height: 100%;
  }
`;



// WEBPACK FOOTER //
// ./src/components/VariationDragDrop/ProductVariationColumn/style.js